import { CookiesProvider } from 'react-cookie';
import { QueryClient, QueryClientProvider } from 'react-query';
import { NotifierContextProvider } from 'react-headless-notifier';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';

import * as Sentry from '@sentry/react';
import { ReactQueryDevtools } from 'react-query/devtools';

import routes from './routes';
import appInfo from '../package.json';
import { UserContextProvider } from './contexts/UserContext';
import { ThemeContextProvider } from './contexts/ThemeContext';
import { PageTitleContextProvider } from './contexts/PageTitleContext';
import { isProd } from './config';
import { Button } from './components/base/Button';
import { PlatformStatus } from './components/shared/PlatformStatus';

console.log(`V${appInfo.version}`);

const sentryCreateBrowserRouter =
  Sentry.wrapCreateBrowserRouter(createBrowserRouter);

const router = sentryCreateBrowserRouter(routes);

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
    },
  },
});

const notifierConfig = {
  max: 3,
  duration: 8000,
  position: 'topRight',
};

function App() {
  if (isProd) {
    console.log = function () {};
    console.warn = function () {};
    console.error = function () {};
  }

  return (
    <QueryClientProvider client={queryClient}>
      <NotifierContextProvider config={notifierConfig}>
        <CookiesProvider>
          <UserContextProvider>
            <ThemeContextProvider>
              <PageTitleContextProvider>
                <PlatformStatus />
                {!isProd ? (
                  <div className="py-2 flex flex-col md:flex-row items-center justify-center md:text-lg text-white bg-red-500">
                    <div className="text-center">
                      <span>You are viewing the</span>
                      <span className="mx-2 font-bold">
                        {import.meta.env.VITE_RUN_ENV}
                      </span>
                      <span>environment</span>
                    </div>
                    <Button
                      size="sm"
                      className="ml-2 !border-none !text-white !bg-red-600 hover:!bg-red-700 active:!bg-red-700"
                      onClick={() =>
                        window.location.assign(
                          'https://sphere.planetdevices.com'
                        )
                      }
                    >
                      Go to Production System
                    </Button>
                  </div>
                ) : (
                  <></>
                )}
                <RouterProvider router={router} />
              </PageTitleContextProvider>
            </ThemeContextProvider>
          </UserContextProvider>
        </CookiesProvider>
      </NotifierContextProvider>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  );
}

export default App;
